import { SelectedAttributeFragment } from '@sdk/gqlTypes/generatedOperations';

const orderedAttributes = [
  'door-style',
  'glass-type',
  'system-style',
  'system-color',
  'system-type',
  'door-color',
  'door-color-paint',
  'door-color-oil',
  'door-color-ash',
  'door-color-rattan',
  'color-samples',
  'handle-color',
  'width',
  'height',
  'track',
  'configuration',
  'door-density',
  'orientation',
];

const orderedMobileAttributes = [
  'width',
  'height',
  'door-color',
  'door-color-paint',
  'door-color-oil',
  'door-color-ash',
  'door-color-rattan',
  'door-style',
  'door-type',
  'glass-type',
  'system-style',
  'system-color',
  'system-type',
  'color-samples',
  'handle-color',
  'track',
  'configuration',
  'door-density',
  'orientation',
];

export const attributesSorter = (
  a: SelectedAttributeFragment,
  b: SelectedAttributeFragment
): number =>
  orderedAttributes.indexOf(a.attribute.slug) -
  orderedAttributes.indexOf(b.attribute.slug);

export const attributesMobileSorter = (
  a: SelectedAttributeFragment,
  b: SelectedAttributeFragment
): number =>
  orderedMobileAttributes.indexOf(a.attribute.slug) -
  orderedMobileAttributes.indexOf(b.attribute.slug);
